export default __webpack_public_path__ + "static/media/logo.9e649d32.svg";